<template lang="pug">
	.page
			.wrapper.wrapper_max
				router-link.back(data-aos="fade-up" :to="'/' + ($route.name.toLowerCase() === 'new' ? 'news' : $route.name.toLowerCase() === 'article' ? 'articles' : '') + '/'") {{ $route.name.toLowerCase() === 'new' ? 'всі новини' : $route.name.toLowerCase() === 'article' ? 'всі Публікації' : '' }}
					span
			.wrapper.wrapper_min
				.new
					.new__title(v-text="page.name" data-aos="fade-up" data-aos-delay="200")
					.new__date(v-text="getDate(page.date)" data-aos="fade-up" data-aos-delay="400")
					.new__content(data-aos="fade-up" data-aos-delay="600")
						.wrapper
							img(:src="page.photo ? page.photo[1200] : ''")
							.new__content__text(v-html="page.content")
			.wrapper(v-if="materials.length && products.length && catalogs.length")
				.cultures
					.cultures__title(data-aos="fade-up") Пов’язані продукти
					.cultures__swiper-container(data-aos="fade-up" data-aos-delay="200")
						.cultures__swiper-wrapper
							swiper.cultures__swiper(ref="swiper2" :options="{allowTouchMove: false,loop: (materials.length >= 4),slidesPerView: 4,breakpoints: {1200: {slidesPerView: 'auto',allowTouchMove: true}}}")
								swiperSlide(
									v-for="(card, index) in materials"
									:key="index"
								)
									section-card(
										:card="card"
										:type="'product'"
										:link="'/products/' + (catalogs.length ? card.category.slug : '') + '/' + card.slug + '/'"
									)
						template(v-if="materials.length > 4")
							button.cultures__arrow.cultures__arrow_left( @click="slidePrev(2)")
							button.cultures__arrow.cultures__arrow_right( @click="slideNext(2)")
					.cultures__bottom(data-aos="fade-up")
						router-link.cultures__more(to='/products/') Всі продукти
							span
			.wrapper(v-if="$route.name.toLowerCase() === 'new'")
				.cultures
					.cultures__title(data-aos="fade-up") Останні новини
					.cultures__swiper-container(data-aos="fade-up" data-aos-delay="200")
						.cultures__swiper-wrapper
							swiper.cultures__swiper(ref="swiper1" v-if="news.length && getLastNews(page.id).length" :options="{allowTouchMove: false,loop: (getLastNews(page.id).length <= 4 ? false : true),slidesPerView: 4,breakpoints: {1200: {slidesPerView: 'auto',allowTouchMove: true}}}")
								swiperSlide(
									v-for="(card, index) in getLastNews(page.id)"
									:key="index"
								)
									section-card(
										:card="card"
										:type="'new_min'"
										:link="'/news/' + card.slug + '/'"
									)
						template(v-if="getLastNews(page.id).length > 4")
							button.cultures__arrow.cultures__arrow_left( @click="slidePrev(1)")
							button.cultures__arrow.cultures__arrow_right( @click="slideNext(1)")
			.wrapper(v-else-if="$route.name.toLowerCase() === 'article'")
				.cultures
					.cultures__title(data-aos="fade-up") Останні публікації
					.cultures__swiper-container(data-aos="fade-up" data-aos-delay="200")
						.cultures__swiper-wrapper
							swiper.cultures__swiper(ref="swiper1" v-if="articles.length && getLastArticles(page.id).length" :options="{allowTouchMove: false,loop: (getLastArticles(page.id).length <= 4 ? false : true),slidesPerView: 4,breakpoints: {1200: {slidesPerView: 'auto',allowTouchMove: true}}}")
								swiperSlide(
									v-for="(card, index) in getLastArticles(page.id)"
									:key="index"
								)
									section-card(
										:card="card"
										:type="'new_min'"
										:link="'/articles/' + card.slug + '/'"
									)
						template(v-if="getLastArticles(page.id).length > 4")
							button.cultures__arrow.cultures__arrow_left( @click="slideNext(1)")
							button.cultures__arrow.cultures__arrow_right( @click="slidePrev(1)")
</template>

<script>

	import {mapState, mapGetters} from 'vuex';

	import sectionCard from '@/components/sectionCard.vue';

	import AOS from 'aos';

	import 'swiper/dist/css/swiper.css'
	import { swiper, swiperSlide } from 'vue-awesome-swiper'

	export default {
		name: 'New',
		metaInfo: function() {
			let th = this;

			return {
				title: th.page.name
			}
		},
		data: function(){
			return {
				page: {},
        type: '',
        productList: [],
			}
		},
		created() {

			this.type = this.$route.name.toLowerCase() === 'new' ? 'news' : this.$route.name.toLowerCase() === 'article' ? 'articles' : '';

			if (!this[this.type].length) this.$store.dispatch('GET_COLLECTION', this.type);
      if (!this.products.length) this.$store.dispatch('GET_COLLECTION', 'products');
      if (!this.catalogs.length) this.$store.dispatch('GET_COLLECTION', 'catalogs');

      if (this[this.type].length) {
				this.page = this.getPostBySlug(this.type, this.$route.params.slug);
			}
		},
		methods: {
			getDate(date) {
				let d = new Date(date);
				var dd = d.getDate();
				var mm = d.getMonth() + 1;

				var yyyy = d.getFullYear();
				if (dd < 10) {
					dd = '0' + dd;
				}
				if (mm < 10) {
					mm = '0' + mm;
				}
				return dd + '.' + mm + '.' + yyyy;
			},
			resizeHandler() {
				setTimeout(() => {
					if (this.$refs.swiper1) this.$refs.swiper1.swiper.update();
					if (this.$refs.swiper2) this.$refs.swiper2.swiper.update();
				});
			},
			slideNext(id) {
        if(id == 1) this.$refs.swiper1.swiper.slideNext();
        if(id == 2) this.$refs.swiper2.swiper.slideNext();
			},
			slidePrev(id) {
        if(id == 1) this.$refs.swiper1.swiper.slidePrev();
        if(id == 2) this.$refs.swiper2.swiper.slidePrev();
			}
		},
		mounted() {
			window.addEventListener('resize', this.resizeHandler, false);

			this.$nextTick(() => {
				AOS.init({
					once: true,
					disabled: 'mobile',
					duration: 1000
				});
			})
		},
		destroyed() {
			window.removeEventListener('resize', this.resizeHandler, false);
		},
		components: {
			'section-card': sectionCard,
			swiper,
			swiperSlide,
		},
		computed: {
			...mapState([
				'news',
				'articles',
        'products',
        'catalogs',
			]),
			...mapGetters([
				'getPostBySlug',
				'getLastNews',
				'getLastArticles',
				'getProductBySlug',
			]),
			materials() {
        let materialsList = [];
        if ( this.page.products && this.catalogs ) {
          for(let product of this.page.products) {
            let productObj = this.getProductBySlug(product.slug)
            if (productObj) {
              let catalogObj = this.catalogs.find(c => c.id === productObj.catalogs[0])
              if (catalogObj) {
                productObj.category = catalogObj;
              }
            }
						materialsList.push(productObj)
          }
        }
        return materialsList
      }
		},
		watch: {
      news() {
        if (this.news.length) {
          this.page = this.getPostBySlug('news', this.$route.params.slug);
        }
      },
      articles() {
        if (this.articles.length) {
          this.page = this.getPostBySlug('articles', this.$route.params.slug);
        }
      },
      $route(to, from) {
         if (to.params.slug !== from.params.slug) {
           this.page = this.getPostBySlug(this.type, this.$route.params.slug);
         }
      }
    }
	}

</script>

<style lang="scss" scoped>

	@import '@/helpers/sass/kit.scss';

	.page {
		margin-top: 0;
		margin-bottom: -8px;
	}

	.back {
		text-transform: uppercase;
		display: inline-block;
		height: 50px;
		background-color: #fff;
		box-shadow: 0px 10px 20px rgba(51, 51, 51, 0.1);
		font: 500 19px/50px 'Helvetica', Arial, sans-serif;
		color: #333333;
		padding: 2px 29px 0 78px;
		letter-spacing: 2px;
		position: relative;

		&:after {
			content: "";
			display: block;
			position: absolute;
			width: calc(100% - 50px);
			height: 100%;
			top: 0;
			right: 0;
			box-shadow: 0px 10px 20px rgba(51, 51, 51, 0.1);
		}

		span {
			display: block;
			position: absolute;
			width: 50px;
			height: 100%;
			top: 0;
			left: 0;
			background: url('../assets/img/back_red.svg') no-repeat center center;
			transition: transform .5s ease;
			transform: translate3d(0, 0, 1px);
		}

		@media screen and (min-width: 1201px) {
			&:hover {
				opacity: .7!important;
				transition: opacity .3s ease;
			}
		}
	}

	.new {
		margin-top: 43px;
		margin-bottom: 100px;

		&__title {
			@include kit('postTitle');
			letter-spacing: 2px;
		}

		&__date {
			color: #EF3E33;
			font: 500 21px/25px 'Helvetica', Arial, sans-serif;
			letter-spacing: 3px;
			margin-left: -5px;
			margin-top: 32px;
		}

		&__content {
			margin: 50px 0;
			letter-spacing: .7px;

			>>> img {
				display: block;
				width: calc(100% + 216px);
				margin: 50px 0;
				margin-left: -108px;
                height: auto;
			}

			>>> strong {
				font-weight: 700;
			}

      >>> a {
          text-decoration: underline;
          color: #EF3E33;
      }

      &__text {
          >>> img {
              max-width: 100%;
              width: auto;
              margin-left: 0;
          }
      }

			.wrapper {
				max-width: 630px;
			}
		}
	}

	.cultures {
		margin-top: 50px;
		margin-bottom: 50px;

		&__title {
			@include kit('sectionTitle');
			margin-left: 0;
			margin-bottom: 25px;
		}

		&__swiper {
			width: calc(100% + 20px);
			margin-left: -10px;
			padding: 30px 0;
		}

		&__swiper-container {
			position: relative;
		}

		&__swiper-wrapper {
			width: 100%;
			height: 100%;
			overflow: hidden;
		}

		&__arrow {
			position: absolute;
			top: 50px;
			width: 50px;
			height: 50px;
			box-shadow: 0px 10px 20px rgba(51, 51, 51, 0.2);
			background-color: #EF3E33;
			z-index: 0;

			&_left {
				background: url('../assets/img/arr_2.svg') #EF3E33 no-repeat center center;
				left: -49px;
			}

			&_right {
				background: url('../assets/img/arr_1.svg') #EF3E33 no-repeat center center;
				right: -49px;
			}
		}

		>>> .card {
			margin-bottom: 57px;
			margin-top: 20px;
		}

		&__bottom {
			text-align: center;
			position: relative;
			z-index: 1;
		}

		&__more {
			height: 50px;
			width: 296px;
			max-width: 100%;
			border: 1px solid #EF3E33;
			position: relative;
			display: inline-block;
			vertical-align: top;
			text-transform: uppercase;
			margin-top: 23px;
			padding-right: 50px;
			text-align: center;
			color: #EF3E33;
			font: 500 19px/52px 'Helvetica', Arial, sans-serif;
			letter-spacing: 2px;
			position: relative;

			span {
				display: block;
				position: absolute;
				top: 0;
				right: 0;
				width: 50px;
				height: 100%;
				background: url('../assets/img/arr_3.svg') no-repeat center center;
				border-left: 1px solid #EF3E33;
			}
		}
	}

	@media screen and (max-width: 1200px) {

		.back {
			margin-left: -20px;
		}

		.new {
			&__content {
				margin: 30px 0;

				.wrapper {
					padding: 0;
				}

				>>> img {
					width: calc(100% + 40px);
					margin: 30px 0;
					margin-left: -20px;
				}

        &__text {
            >>> img {
                max-width: 100%;
                width: auto;
                margin-left: 0;
            }
        }
			}
		}

		.cultures {
			margin-bottom: 105px;

			&__title {
				margin-bottom: 36px;
			}
			&__arrow {
				display: none;
			}

			&__more {
				margin-top: 50px;
			}

			.section__swiper-container {
				width: calc(100% + 40px);
				margin-left: 0px;
			}

			>>> .swiper-slide {
				padding: 0 10px;
				width: 266px;
			}

			>>> .card {
				width: 246px;
				margin: 0;
			}
		}
	}

</style>
